import React, { useEffect, useState, useRef } from 'react';
import './GlobalApproach.css';
import logo from '../../assets/Logo_Prosperian_Blanc.png';

const GlobalApproach = () => {
  const [textColor, setTextColor] = useState({ title: 'white', description: 'rgba(255, 255, 255, 0.8)' });
  const [diagramStyle, setDiagramStyle] = useState({
    container: { 
      backgroundColor: 'rgba(255, 255, 255, 0.03)',
      borderColor: 'rgba(255, 255, 255, 0.1)'
    },
    items: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      borderColor: 'rgba(255, 255, 255, 0.1)',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)'
    }
  });
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const sectionHeight = rect.height;
        const sectionTop = rect.top;
        
        // Calculer la progression du défilement par rapport à la position de la section
        const scrollProgress = (viewportHeight - sectionTop) / (viewportHeight + sectionHeight);
        
        // Définir le point où la transition commence et finit
        const transitionStart = 0.5;
        const transitionDuration = 0.25;
        
        if (scrollProgress > transitionStart) {
          // Calculer un facteur de transition entre 0 et 1
          const transitionFactor = Math.min((scrollProgress - transitionStart) / transitionDuration, 1);
          
          // Interpoler les couleurs entre blanc et noir (0c1220 = rgb(12, 18, 32))
          const titleRed = Math.round(255 - (255 - 12) * transitionFactor);
          const titleGreen = Math.round(255 - (255 - 18) * transitionFactor);
          const titleBlue = Math.round(255 - (255 - 32) * transitionFactor);
          
          // Ajuster l'opacité pour la description
          const descOpacity = 0.8;
          
          setTextColor({
            title: `rgb(${titleRed}, ${titleGreen}, ${titleBlue})`,
            description: `rgba(${titleRed}, ${titleGreen}, ${titleBlue}, ${descOpacity})`
          });
          
          // Transition du diagramme
          setDiagramStyle({
            container: {
              backgroundColor: `rgba(255, 255, 255, ${0.03 + 0.97 * transitionFactor})`,
              borderColor: `rgba(200, 200, 200, ${0.1 + 0.2 * transitionFactor})`
            },
            items: {
              backgroundColor: `rgba(255, 255, 255, ${0.4 + 0.6 * transitionFactor})`,
              borderColor: `rgba(200, 200, 200, ${0.1 + 0.2 * transitionFactor})`,
              boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)'
            }
          });
        } else {
          setTextColor({
            title: 'white',
            description: 'rgba(255, 255, 255, 0.8)'
          });
          
          setDiagramStyle({
            container: {
              backgroundColor: 'rgba(255, 255, 255, 0.03)',
              borderColor: 'rgba(255, 255, 255, 0.1)'
            },
            items: {
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
              borderColor: 'rgba(255, 255, 255, 0.1)',
              boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)'
            }
          });
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Débouncer la fonction pour améliorer les performances
    const debouncedHandleScroll = debounce(handleScroll, 10);
    window.addEventListener('scroll', debouncedHandleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', debouncedHandleScroll);
    };
  }, []);

  // Fonction utilitaire pour debouncer les événements de scroll
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  return (
    <section className="global-approach" ref={sectionRef}>
      <div className="approach-container">
        <div className="approach-content">
          <div className="approach-text">
            <div className="approach-label" style={{ color: textColor.title }}>PROSPERIAN SCORE</div>
            <h2 className="approach-title" style={{ color: textColor.title }}>
              Un accompagnement à la performance
            </h2>
            <div className="approach-description" style={{ color: textColor.description }}>
              <p>
                Évaluez la maturité commerciale de votre entreprise et identifiez les axes d'amélioration prioritaires pour optimiser vos résultats.
              </p>
              <p style={{ marginTop: '25px' }}>
                <a 
                  href="https://www.videoask.com/fd8vz299c" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="approach-button"
                >
                  Découvrir votre Prosperian Score©
                </a>
              </p>
            </div>
          </div>
          <div className="approach-diagram">
            <div className="diagram-container" style={{
              backgroundColor: diagramStyle.container.backgroundColor,
              borderColor: diagramStyle.container.borderColor,
              transition: 'background-color 0.5s ease-in-out, border-color 0.5s ease-in-out'
            }}>
              <div className="diagram-center" style={{
                backgroundColor: diagramStyle.container.backgroundColor,
                transition: 'background-color 0.5s ease-in-out'
              }}>
                <img src={logo} alt="Junto" className="diagram-logo" />
              </div>
              <div className="diagram-items">
                <div className="diagram-item item-media" style={{
                  backgroundColor: diagramStyle.items.backgroundColor,
                  borderColor: diagramStyle.items.borderColor,
                  boxShadow: diagramStyle.items.boxShadow,
                  transition: 'background-color 0.5s ease-in-out, border-color 0.5s ease-in-out, box-shadow 0.5s ease-in-out'
                }}>
                  <span>STRATÉGIE</span>
                </div>
                <div className="diagram-item item-seo" style={{
                  backgroundColor: diagramStyle.items.backgroundColor,
                  borderColor: diagramStyle.items.borderColor,
                  boxShadow: diagramStyle.items.boxShadow,
                  transition: 'background-color 0.5s ease-in-out, border-color 0.5s ease-in-out, box-shadow 0.5s ease-in-out'
                }}>
                  <span>OUTILS</span>
                </div>
                <div className="diagram-item item-data" style={{
                  backgroundColor: diagramStyle.items.backgroundColor,
                  borderColor: diagramStyle.items.borderColor,
                  boxShadow: diagramStyle.items.boxShadow,
                  transition: 'background-color 0.5s ease-in-out, border-color 0.5s ease-in-out, box-shadow 0.5s ease-in-out'
                }}>
                  <span>DATA</span>
                </div>
                <div className="diagram-item item-design" style={{
                  backgroundColor: diagramStyle.items.backgroundColor,
                  borderColor: diagramStyle.items.borderColor,
                  boxShadow: diagramStyle.items.boxShadow,
                  transition: 'background-color 0.5s ease-in-out, border-color 0.5s ease-in-out, box-shadow 0.5s ease-in-out'
                }}>
                  <span>ORGANISATION</span>
                </div>
                <div className="diagram-item item-crm" style={{
                  backgroundColor: diagramStyle.items.backgroundColor,
                  borderColor: diagramStyle.items.borderColor,
                  boxShadow: diagramStyle.items.boxShadow,
                  transition: 'background-color 0.5s ease-in-out, border-color 0.5s ease-in-out, box-shadow 0.5s ease-in-out'
                }}>
                  <span>CRM</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalApproach;